module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "webdatalist"
  }, [_c('div', {
    staticClass: "showLargeScreenOnly"
  }, [_c('f7-list', {
    staticClass: "searchbar-found",
    attrs: {
      "media-list": "",
      "id": "group-list"
    }
  }, _vm._l((_vm.filteredUserAccounts), function(group, key) {
    return _c('f7-list-group', {
      key: key
    }, [_c('f7-list-item', {
      attrs: {
        "title": key,
        "group-title": ""
      }
    }), _vm._v(" "), _vm._l((group), function(membersGroup) {
      return _c('li', {
        key: membersGroup.id
      }, [_c('div', {
        staticClass: "item-content boxRequest"
      }, [_c('div', {
        staticClass: "item-inner",
        on: {
          "click": function($event) {
            return _vm.editContactGroup(membersGroup)
          }
        }
      }, [_c('div', {
        staticClass: "item-title"
      }, [_vm._v(_vm._s(membersGroup.name))])]), _vm._v(" "), _c('div', {
        staticClass: "item-media"
      }, [_c('button', {
        staticClass: "button-swipe-out",
        on: {
          "click": function($event) {
            return _vm.deleteTeamWeb(membersGroup)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times-circle button-delete"
      })])])])])
    })], 2)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "showSmallScreenOnly"
  }, [_c('f7-list', {
    staticClass: "searchbar-found",
    attrs: {
      "media-list": "",
      "id": "group-list"
    }
  }, _vm._l((_vm.filteredUserAccounts), function(group, key) {
    return _c('f7-list-group', {
      key: key
    }, [_c('f7-list-item', {
      attrs: {
        "title": key,
        "group-title": ""
      }
    }), _vm._v(" "), _vm._l((group), function(membersGroup) {
      return _c('f7-list-item', {
        key: membersGroup.id,
        staticClass: "boxRequest",
        attrs: {
          "swipeout": "",
          "title": membersGroup.name
        },
        on: {
          "swipeout:deleted": function($event) {
            return _vm.deleteTeam(membersGroup)
          },
          "click": function($event) {
            return _vm.editContactGroup(membersGroup)
          }
        }
      }, [_c('f7-swipeout-actions', [_c('f7-swipeout-button', {
        staticClass: "swipeout-create action3",
        attrs: {
          "href": "/accountMembers/addMemberGroup/",
          "close": ""
        }
      }, [_vm._v("Edit")]), _vm._v(" "), _c('f7-swipeout-button', {
        attrs: {
          "delete": ""
        }
      }, [_vm._v("Remove")])], 1)], 1)
    })], 2)
  }), 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ccc3befa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ccc3befa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/accounts/CMAccountMembersPage/CMAccountMembersGroupList.vue
// module id = 1720
// module chunks = 2